import { default as axios } from "axios";
import { make_url } from "../../helpers/functions";

let OneTrustService = {
  isOn(key) {
    return (window.OnetrustActiveGroups ?? "").indexOf(key) !== -1;
  },
  attachCallback() {
    let that = this;
    if (
      typeof window.OneTrust === "undefined" ||
      typeof window.OneTrust.OnConsentChanged === "undefined"
    ) {
      setTimeout(function () {
        that.attachCallback();
      }, 100);
    } else {
      that.syncGroups();

      window.OneTrust.OnConsentChanged(function () {
        let dataLayer = window.dataLayer || [];
        dataLayer.push({ event: "OneTrustGroupsUpdatedConsentSaved" });
        that.syncGroups();
      });
    }
  },
  syncGroups() {
    if (
      typeof window.OnetrustActiveGroups !== "undefined" &&
      window.OnetrustActiveGroups !== window.OnetrustActiveGroupsSynced
    ) {
      axios
        .post(
          make_url("/onetrust" + window.location.search),
          "groups=" + window.OnetrustActiveGroups,
        )
        .then(function (response) {
          window.OnetrustActiveGroupsSynced = response.data.groups;
        });
    }
  },
};

export default OneTrustService;
